import {enableProdMode, ErrorHandler, importProvidersFrom, LOCALE_ID} from '@angular/core';
import {environment} from './environments/environment';
import {AppComponent} from './app/app.component';
import {LoadingBarRouterModule} from '@ngx-loading-bar/router';
import {ToastrModule} from 'ngx-toastr';
import {provideAnimations} from '@angular/platform-browser/animations';
import {bootstrapApplication} from '@angular/platform-browser';
import {LoaderHttpXhrBackend} from './app/common/loader.http.xhr.backend';
import {HttpHandler, provideHttpClient} from '@angular/common/http';
import {
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MAT_MOMENT_DATE_FORMATS,
  MatMomentDateModule,
  MomentDateAdapter
} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {registerLocaleData} from '@angular/common';
import localeDe from '@angular/common/locales/de';
import localeDeExtra from '@angular/common/locales/extra/de';
import {CustomErrorHandler} from './app/common/custom-error.handler';
import {AppRoutingModule} from './app/app-routing.module';
import {MatDialogModule} from '@angular/material/dialog';
import moment from 'moment';
import 'moment/locale/de';

moment.locale('de');
registerLocaleData(localeDe, 'de-DE', localeDeExtra);

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      ToastrModule.forRoot({
        preventDuplicates: true,
        progressBar: true,
        timeOut: 5000,
        enableHtml: true,
        positionClass: 'toast-bottom-right'
      }),
      LoadingBarRouterModule,
      MatDialogModule,
      MatMomentDateModule,
      AppRoutingModule,
    ),
    provideHttpClient(),
    provideAnimations(),
    {provide: HttpHandler, useClass: LoaderHttpXhrBackend},
    {provide: ErrorHandler, useClass: CustomErrorHandler},
    {provide: MAT_DATE_LOCALE, useValue: 'de-DE'},
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]},
    {provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS},
    {provide: LOCALE_ID, useValue: 'de-DE'},
  ]
}).then().catch(err => console.log(err));
